// extracted by mini-css-extract-plugin
export var container = "_i6-0";
export var content = "_i6-3";
export var customerTitle = "_i6-4";
export var empty = "_i6-5";
export var gray = "_i6-6";
export var header = "_i6-7";
export var info = "_i6-8";
export var loading = "_i6-2";
export var loadingCard = "_i6-9";
export var oneLine = "_i6-a";
export var personName = "_i6-e";
export var pillContainer = "_i6-b";
export var selected = "_i6-1";
export var text = "_i6-c";
export var twoLines = "_i6-d";
export var unread = "_i6-f";
export var unreadIndicator = "_i6-g";